import { Button } from "@/components/ui/button";
import { useState } from "react";
import { Play } from "lucide-react";

export default function VSLSection() {
  const [isVideoLoaded, setIsVideoLoaded] = useState(false);
  const videoId = "lE7JBgS8bcg";
  
  return (
    <section id="vsl" className="relative py-20 md:py-32 px-6 bg-medium-navy">
      <div className="max-w-6xl mx-auto text-center">
        {/* Badge */}
        <div className="inline-block px-4 py-1 rounded-full border border-cyan/30 bg-cyan/5 mb-6 text-xs text-cyan font-bold uppercase tracking-wider">
          See It in Action
        </div>

        {/* Headline */}
        <h2 className="text-4xl md:text-5xl font-bold text-foreground mb-4">
          From Missed Leads to 3× More Pipeline — The System That Thinks, Closes, and Scales
        </h2>

        {/* Subheading */}
        <p className="text-lg md:text-xl text-light-gray/80 mb-12 max-w-2xl mx-auto">
          2-minute breakdown of real client results, real automation, and real ROI.
        </p>

        {/* Video Player */}
        <div className="relative max-w-4xl mx-auto mb-10 fade-in-up">
          <div
            className="relative rounded-2xl overflow-hidden border-2 border-cyan/20 shadow-lg hover:border-cyan/40 hover:scale-[1.03] transition-all duration-300 cursor-pointer"
            style={{
              aspectRatio: "16 / 9",
              boxShadow: "0 4px 20px rgba(0, 0, 0, 0.15), 0 0 30px rgba(0, 217, 255, 0.25), inset 0 1px 3px rgba(0, 0, 0, 0.2)",
            }}
            onClick={() => setIsVideoLoaded(true)}
          >
            {!isVideoLoaded ? (
              <>
                <img
                  src={`https://img.youtube.com/vi/${videoId}/maxresdefault.jpg`}
                  alt="ArqeraAI Demo Video Thumbnail"
                  className="absolute inset-0 w-full h-full object-cover"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-black/30 flex items-center justify-center group-hover:bg-black/40 transition-colors">
                  <div className="bg-primary/90 rounded-full p-6 group-hover:scale-110 transition-transform">
                    <Play className="w-12 h-12 text-white fill-white" />
                  </div>
                </div>
              </>
            ) : (
              <iframe
                className="absolute inset-0 w-full h-full"
                src={`https://www.youtube-nocookie.com/embed/${videoId}?autoplay=1`}
                title="ArqeraAI Demo Video"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              />
            )}
          </div>
        </div>

        {/* CTA */}
        <div className="text-center">
          <p className="text-lg text-light-gray mb-6">
            Ready to see your custom plan?
          </p>
          <Button
            asChild
            size="lg"
            className="bg-cyan text-white hover:bg-cyan/90 hover:scale-105 transition-all duration-200 shadow-lg hover:shadow-cyan/50 w-full sm:w-auto px-10 py-6 text-base"
          >
            <a
              href="https://calendly.com/arqeraai-strategy-call/"
              target="_blank"
              rel="noopener noreferrer"
            >
              Book Your Strategy Call
            </a>
          </Button>
        </div>
      </div>
    </section>
  );
}
